import * as React from 'react';

import { Button, Col, ColProps, Divider, Popover, Row } from 'antd';

import { ConnectionIndicator } from 'src/components/connectionIndicator';
import { FullscreenButton } from 'src/components/fullscreenButton';
import { LanguagePicker } from 'src/components/languagePicker';
import { ReloadButton } from 'src/components/reloadButton';
import { ThemeButton } from 'src/components/themeButton';
import { ToolOutlined } from '@ant-design/icons';
import applicationInfo from 'src/utility/applicationInfo';
import { useFullscreen } from 'src/hooks/useFullscreen';

const appControls: React.FC = (props) => {
    const { version, build } = applicationInfo;
    const { isFullscreenEnabled } = useFullscreen();

    const [areToolsOpen, setAreToolsOpen] = React.useState(false);

    const colProps: ColProps = {
        span: 24,
        style: { margin: '10px 0' },
    };

    const buttonColProps: ColProps = {
        ...colProps,
        onClick: () => setAreToolsOpen(false),
    };

    return (
        <Popover
            destroyTooltipOnHide={true}
            trigger="click"
            placement="bottomRight"
            onOpenChange={(visible) => setAreToolsOpen(visible)}
            open={areToolsOpen}
            content={
                <Row
                    style={{ maxWidth: '400px' }}
                >
                    <Col
                        {...colProps}
                    >
                        <LanguagePicker
                            style={{ width: '100%' }}
                        />
                    </Col>

                    <Divider />

                    <Col
                        {...buttonColProps}
                    >
                        <ThemeButton
                            style={{ width: '100%' }}
                        />
                    </Col>

                    <Col
                        {...buttonColProps}
                    >
                        <ReloadButton
                            style={{ width: '100%' }}
                        />
                    </Col>

                    {isFullscreenEnabled &&
                        <Col
                            {...buttonColProps}
                        >
                            <FullscreenButton
                                style={{ width: '100%' }}
                            />
                        </Col>
                    }
                </Row>
            }
            title={
                <Row
                    align="middle"
                    justify="space-between"
                >
                    <Col>
                        {`exit-interview v${version}${build ? ` - Build: ${build}` : ''}`}
                    </Col>

                    <Col>
                        <ConnectionIndicator />
                    </Col>
                </Row>
            }
        >
            <Button
                icon={<ToolOutlined />}
                style={{ marginRight: 16 }}
                onClick={() => setAreToolsOpen(!areToolsOpen)}
                shape="circle"
            />
        </Popover>
    );
};

export const AppControls = React.memo(appControls);